/**
 * Application route constants
 * Centralized route definitions for consistent navigation
 */

export const ROUTES = {
  HOME: "/",
  MARKET: "/market",
  SERVERS: "/servers",
  ROADMAP: "/roadmap",
  NEWS: "/news",
  NEWS_PREVIEW: "/news/preview/:token",
  NEWS_EDITOR: "/news/editor",
  NEWS_EDIT: "/news/editor/:id",
  FAQ: "/faq",
  DASHBOARD: "/dashboard",
};

export default ROUTES;
